import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.starts-with.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        query checkStore {\n          viewer {\n            store {\n              adminStatus\n              metaData {\n                storeStatus\n              }\n            }\n          }\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        query checkStore {\n          viewer {\n            store {\n              adminStatus\n              metaData {\n                storeStatus\n              }\n            }\n          }\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          query checkAdminToken($token: String!) {\n            isAdministratorToken(token: $token)\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// import
import { HttpLink, gql } from '@apollo/client';
import { buildWithApollo } from '@meepshop/apollo';
import { resolvers } from '@store/apollo';
import { appWithDomain, getServerSideDomainContextProps, getClientSideDomainContextProps } from '@meepshop/link';
import appWithPageError from '@meepshop/page-error';
import { appWithCookies, getServerSideCookiesContextProps, getClientSideCookiesContextProps } from "./withCookies"; // definition

var hoc = function hoc(App) {
  return appWithDomain(appWithPageError(appWithCookies(App)));
};

var getServerSideAppProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    var _ctx$ctx, req, client, query, _yield$fetch$then, valid, _store$metaData, _yield$client$query, data, _yield$client$query2, store, storeStatus, adminStatus;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ctx$ctx = ctx.ctx, req = _ctx$ctx.req, client = _ctx$ctx.client, query = _ctx$ctx.query;
            _context.next = 3;
            return fetch("".concat(process.env.MEEPSHOP_API, "/auth/validate_token"), {
              method: 'POST',
              credentials: 'include',
              headers: {
                'content-type': 'application/json'
              },
              body: JSON.stringify({
                token: req.cookies['x-meepshop-authorization-token']
              })
            }).then(function (result) {
              return result.json();
            });

          case 3:
            _yield$fetch$then = _context.sent;
            valid = _yield$fetch$then.valid;

            if (!valid) {
              delete req.cookies['x-meepshop-authorization-token'];
            }

            _context.prev = 6;

            if (!(req.url.startsWith('/admin') && query.token)) {
              _context.next = 14;
              break;
            }

            _context.next = 10;
            return client.query({
              query: gql(_templateObject()),
              variables: {
                token: query.token
              }
            });

          case 10:
            _yield$client$query = _context.sent;
            data = _yield$client$query.data;

            if (data !== null && data !== void 0 && data.isAdministratorToken) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", {
              error: {
                status: 'ERROR_PAGE_NOT_FOUND'
              }
            });

          case 14:
            _context.next = 16;
            return client.query({
              query: gql(_templateObject2())
            });

          case 16:
            _yield$client$query2 = _context.sent;
            store = _yield$client$query2.data.viewer.store;
            storeStatus = store === null || store === void 0 ? void 0 : (_store$metaData = store.metaData) === null || _store$metaData === void 0 ? void 0 : _store$metaData.storeStatus;
            adminStatus = store === null || store === void 0 ? void 0 : store.adminStatus;
            _context.t0 = _objectSpread;
            _context.t1 = _objectSpread;
            _context.t2 = _objectSpread;
            _context.t3 = _objectSpread({}, storeStatus === 'CLOSE' ? {
              closed: adminStatus === 'OPEN' ? 'RESTED' : 'CLOSED'
            } : {});
            _context.next = 26;
            return getServerSideCookiesContextProps(ctx.ctx);

          case 26:
            _context.t4 = _context.sent;
            _context.t5 = (0, _context.t2)(_context.t3, _context.t4);
            _context.t6 = getServerSideDomainContextProps(ctx.ctx, ctx.router);
            _context.t7 = (0, _context.t1)(_context.t5, _context.t6);
            _context.t8 = {};
            _context.t9 = {
              pageProps: {
                userAgent: ctx.ctx.req.headers['user-agent']
              }
            };
            return _context.abrupt("return", (0, _context.t0)(_context.t7, _context.t8, _context.t9));

          case 35:
            _context.prev = 35;
            _context.t10 = _context["catch"](6);
            _context.t11 = _objectSpread;
            _context.t12 = _objectSpread;
            _context.t13 = _objectSpread;
            _context.t14 = {
              error: _context.t10
            };
            _context.next = 43;
            return getServerSideCookiesContextProps(ctx.ctx);

          case 43:
            _context.t15 = _context.sent;
            _context.t16 = (0, _context.t13)(_context.t14, _context.t15);
            _context.t17 = getServerSideDomainContextProps(ctx.ctx, ctx.router);
            _context.t18 = (0, _context.t12)(_context.t16, _context.t17);
            _context.t19 = {};
            _context.t20 = {
              pageProps: {
                namespacesRequired: ["common", "activity", "cart", "ducks", "login", "order-product-list", "order-show-total", "payment-default-form-item", "product-list", "receiver-default-form-item", "spinner", "validate-mobile"]
              }
            };
            return _context.abrupt("return", (0, _context.t11)(_context.t18, _context.t19, _context.t20));

          case 50:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 35]]);
  }));

  return function getServerSideAppProps(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getClientSideAppProps = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ctx) {
    var client, _store$metaData2, _yield$client$query3, store, storeStatus, adminStatus;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = ctx.ctx.client;
            _context2.prev = 1;
            _context2.next = 4;
            return client.query({
              query: gql(_templateObject3())
            });

          case 4:
            _yield$client$query3 = _context2.sent;
            store = _yield$client$query3.data.viewer.store;
            storeStatus = store === null || store === void 0 ? void 0 : (_store$metaData2 = store.metaData) === null || _store$metaData2 === void 0 ? void 0 : _store$metaData2.storeStatus;
            adminStatus = store === null || store === void 0 ? void 0 : store.adminStatus;
            _context2.t0 = _objectSpread;
            _context2.t1 = _objectSpread;
            _context2.t2 = _objectSpread;
            _context2.t3 = _objectSpread({}, storeStatus === 'CLOSE' ? {
              closed: adminStatus === 'OPEN' ? 'RESTED' : 'CLOSED'
            } : {});
            _context2.next = 14;
            return getClientSideCookiesContextProps(ctx.ctx);

          case 14:
            _context2.t4 = _context2.sent;
            _context2.t5 = (0, _context2.t2)(_context2.t3, _context2.t4);
            _context2.t6 = getClientSideDomainContextProps();
            _context2.t7 = (0, _context2.t1)(_context2.t5, _context2.t6);
            _context2.t8 = {};
            _context2.t9 = {
              pageProps: {
                userAgent: window.navigator.userAgent
              }
            };
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t7, _context2.t8, _context2.t9));

          case 23:
            _context2.prev = 23;
            _context2.t10 = _context2["catch"](1);
            _context2.t11 = _objectSpread;
            _context2.t12 = _objectSpread;
            _context2.t13 = _objectSpread;
            _context2.t14 = {
              error: _context2.t10
            };
            _context2.next = 31;
            return getClientSideCookiesContextProps(ctx.ctx);

          case 31:
            _context2.t15 = _context2.sent;
            _context2.t16 = (0, _context2.t13)(_context2.t14, _context2.t15);
            _context2.t17 = getClientSideDomainContextProps();
            _context2.t18 = (0, _context2.t12)(_context2.t16, _context2.t17);
            _context2.t19 = {};
            _context2.t20 = {
              pageProps: {
                namespacesRequired: ["common", "activity", "cart", "ducks", "login", "order-product-list", "order-show-total", "payment-default-form-item", "product-list", "receiver-default-form-item", "spinner", "validate-mobile"]
              }
            };
            return _context2.abrupt("return", (0, _context2.t11)(_context2.t18, _context2.t19, _context2.t20));

          case 38:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 23]]);
  }));

  return function getClientSideAppProps(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var _buildWithApollo = buildWithApollo({
  hoc: hoc,
  getServerSideAppProps: getServerSideAppProps,
  getClientSideAppProps: getClientSideAppProps,
  name: 'store',
  resolvers: resolvers,
  terminatingLink: new HttpLink(),
  errorFilter: function errorFilter(_ref3) {
    var message = _ref3.message;
    return message !== '[repository] getOrderWithProductsByIdProtectedScope error';
  }
}),
    appWithApollo = _buildWithApollo.appWithApollo;

export { appWithApollo };